export interface GetReserveConditionRequest {
  branchCode: string
  userType: string
}

export function GetReserveConditionRequestToJSON(
  value: GetReserveConditionRequest
): any {
  return {
    branch_code: value.branchCode !== '' ? value.branchCode : undefined,
    user_type: value.userType !== '' ? value.userType : undefined
  }
}
